export const initialState = {
  triggeringScan: false,
};

export function TRIGGER_SCAN(nextState, { triggeringScan }) {
  nextState.triggeringScan = triggeringScan;
}
